// Document categories shared between admin upload and doc list display
export const DOC_CATEGORIES = [
  { value: "Visa Application Form", emoji: "📋" },
  { value: "Flight Reservation", emoji: "✈️" },
  { value: "Hotel Booking", emoji: "🏨" },
  { value: "Car Rental", emoji: "🚗" },
  { value: "Travel Insurance", emoji: "🛡️" },
  { value: "Cover Letter", emoji: "📝" },
  { value: "Travel Itinerary", emoji: "🗺️" },
  { value: "No Objection Certificate", emoji: "💼" },
  { value: "Sponsor Letter", emoji: "👥" },
  { value: "Invitation Letter", emoji: "🏠" },
  { value: "Other", emoji: "📄" },
];

export function categoryMeta(value) {
  return DOC_CATEGORIES.find((c) => c.value === value) || DOC_CATEGORIES[DOC_CATEGORIES.length - 1];
}

export function backendDocUrl(orderId, index) {
  const base = process.env.REACT_APP_BACKEND_URL;
  return `${base}/api/orders/${orderId}/documents/${index}`;
}
